import { Component } from '@angular/core';
import { NavigateService } from '@core/routes/services/navigate.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'df-master-visuals',
  templateUrl: './master-visuals.component.html',
})
export class MasterVisualsComponent {
  funnelId: number;
  docName: string;

  constructor(
    private readonly n: NavigateService,
    private route: ActivatedRoute,
  ) {
    this.funnelId = this.route?.parent?.snapshot.params['id'];
    this.docName = this.route?.parent?.snapshot.queryParams['docName'];
  }
  onNextButtonClick() {
    this.n.go(`/funnels/f/d/${this.funnelId}/campaign`, { id: this.funnelId });
  }
}
